import { LevelColor, ReferenceLine } from '@types';

export const getLevelColor = (key: string): LevelColor => {
  switch (key) {
    case 'p0':
      return { key, color: 'blue', strokeWidth: 3 };
    case 'p+1':
    case 'p-1':
      return { key, color: 'orange', strokeWidth: 2 };
    case 'p+2':
    case 'p-2':
      return { key, color: 'red', strokeWidth: 1 };
    default:
      return { key, color: 'gray', strokeWidth: 1 };
  }
};

// Helper per generare le reference lines a partire dai livelli di variazione
export const generateReferenceLines = (
  levels: { key: string; value: number }[]
): ReferenceLine[] =>
  levels.map(level => {
    const { color, strokeWidth } = getLevelColor(level.key);
    return {
      y: level.value,
      color,
      label: `${level.key}: ${Math.round(level.value)} bpm`,
      strokeWidth,
    };
  });
